
import Vue from "vue";
import { Getter, Action } from "vuex-class";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import config from "@/params/config";
import rely from "@/nmb/oauth2/oauth2rely";
import axios from "axios";

@Component
export default class FileTable extends Vue {
  @Prop() confirmFileList: Function;
  @Prop() deleteFileList: Function;
  @Prop() isActivation: boolean;

  @Prop({ default: false }) canDonwload: boolean;
  action: string = config.neo + config.uploadPrefix;
  header: any = {};
  // 文件列表
  fileList: any[] = [];
  defaultFileList: any[] = [];
  selectedAttachment: any[] = [];
  // 删除的文件夹
  deletefileList:any[]=[];

  previewVisible: boolean = false;
  previewFileUrl: string = "";

  uploadLoading: boolean = false;
  uploadVisible: boolean = false;
  uploadBlob:any = null;
  uploadFileUrl: string = "";
  uploadFileName: string = "screenshot-1";

  created() {
    const tokens = rely.getTokens();
    this.header.Authorization = `Bearer ${tokens.access_token}`;
    this.initPaste()
  }
  // 监听paste事件
  initPaste(){
    let me = this
    document.addEventListener('paste', function (e:any) {
      const dataTransferItemList = e.clipboardData.items;
      // 过滤非图片类型
      const items = [].slice.call(dataTransferItemList).filter(function (item:any) {
          return item.type.indexOf('image') !== -1;
      });
      if (items.length === 0) {
          return;
      }
      const dataTransferItem:any = items[0];
      me.uploadBlob = dataTransferItem.getAsFile();
      const reader = new FileReader()
      reader.onload = function(event:any) {
          me.uploadFileUrl = event.target.result
      }
      reader.readAsDataURL(me.uploadBlob);
      me.uploadVisible = true
      
    });
  }
  // 取消粘贴
  cancelPaste(){
    this.uploadVisible = false
    this.uploadLoading = false
    this.uploadBlob = null;
    this.uploadFileUrl = "";
    this.uploadFileName = "screenshot1"
  }
  // 上传图片至后台
  uploadPaste(){
      if(!this.uploadFileName){
        this.$message.warning(`文件名不能为空`);
        return
      }
      if(this.uploadFileName.indexOf('.npg')==-1){
        this.uploadFileName=`${this.uploadFileName}.png`;
      }
      const tokens = rely.getTokens();
      const formData = new window.FormData()
      const file = new File([this.uploadBlob], this.uploadFileName);
      formData.append('file', file)
      const axiosConfig = {
        method: "post",
        url: this.action,
        headers: {
          Authorization: `Bearer ${tokens.access_token}`
        },
        data:formData
      };
      this.uploadLoading = true
      axios(axiosConfig).then(res => {
        this.fileList.push({
          percent: 100,
          fileName:res.data.Data.fileName,
          filePath:res.data.Data.filePath,
          name: res.data.Data.fileName,
          size:res.data.Data.size,
          old:false,
          canDeleted: true,
        })        
        // 推送文件列表到表单
        this.confirmFileList(this.fileList);
        this.cancelPaste()        
      }).catch((err: any) => {
        this.cancelPaste()
        this.$message.error(`文件上传失败`);
      });
  }

  // 加载之前上传的文件
  setDefaultFileList(fileList: any[]) {    
    this.defaultFileList = [];
    fileList.forEach(item => {
      if (!!item) {
        this.defaultFileList.push({
          uid: item.uid,
          name: item.name,
          size: item.size,
          percent: 100,
          fileName: item.fileName,
          filePath: item.filePath,
          canDeleted: true,
          old:true,
          id:item.id
        });
      }
    });
  }

  // 添加文件列表
  appendFileList(fileList: any[]) {
    this.fileList = this.fileList.concat(fileList);
  }

  fileCanPreview(name: string) {
    return (
      name.endsWith("jpg") ||
      name.endsWith("bmp") ||
      name.endsWith("jpeg") ||
      name.endsWith("png")
    );
  }

  previewFile(val: any) {
    if (!this.fileCanPreview(val.name)) {
      return;
    }
    const tokens = rely.getTokens();
    const axiosConfig = {
      method: "get",
      url: `${config.neo}/Upload/FileLoad${val.filePath}`,
      headers: {
        Authorization: `Bearer ${tokens.access_token}`
      },
      responseType: "blob"
    };

    axios(axiosConfig)
      .then(res => {
        const blob = res.data;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e: any) => {
          this.previewFileUrl = e.target.result;
          this.previewVisible = true;
        };
      })
      .catch((err: any) => {
        this.$message.error(`文件预览失败`);
      });
  }

  downloadFile(fileName: string, filePath: string) {
    const tokens = rely.getTokens();
    const axiosConfig = {
      method: "get",
      url: `${config.neo}/Upload/FileLoad${filePath}`,
      headers: {
        Authorization: `Bearer ${tokens.access_token}`
      },
      responseType: "blob"
    };

    axios(axiosConfig)
      .then(res => {
        const blob = res.data;
        if (window.navigator.msSaveBlob) {
          // IE10+ 使用的下载方式
          return window.navigator.msSaveBlob(blob, fileName);
        }
        // 其他浏览器下载方式
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e: any) => {
          const a: any = document.createElement("a");
          a.download = fileName;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      })
      .catch((err: any) => {
        this.$message.error(`文件${fileName}下载失败`);
      });
  }

  // 下载附件
  downloadAttachment() {
    const fileList: any[] = this.selectedAttachment;
    if (fileList.length === 0) {
      return this.$message.warning("请选择需要下载的附件");
    }
    for (const item of fileList) {
      this.downloadFile(item.fileName, item.filePath);
    }
  }

  // 选择需要下载的附件
  handleSelectionChange(val: any[]) {
    this.selectedAttachment = val;
  }

  // 准备上传
  handlerBeforeUpload(file: any) {
    if (file.size > 1024 * 1024 * 20) {
      this.$message({ type: "warning", message: `文件上传限制为20M` });

      return false;
    } else if (file.size === 0) {
      this.$message({ type: "warning", message: `文件${file.name}大小为空` });

      return false;
    } else {
      this.fileList.push({
        id:file.id,
        uid: file.uid,
        name: file.name,
        size: file.size,
        canDeleted: true,
        percent: 0
      });
    }

        // 上传文件时，禁用提交按钮
    this.$emit("setsubdisabled",true);
    this.$emit("refresh",true);
  }

  // 上传过程中
  handleProgress(e: any, file: any) {
    for (const item of this.fileList) {
      if (item.uid === file.uid) item.percent = Math.floor(e.percent);
    }
  }

  // 上传成功
  handleSuccess(response: any, file: any, fileList: any) {    
    // 完善文件信息
    const cuurentFile = this.fileList.find(
      (item: any) => item.uid === file.uid
    );
    cuurentFile.percent = 100;
    cuurentFile.fileName = file.response.Data.fileName;
    cuurentFile.filePath = file.response.Data.filePath;
    // 推送文件列表到表单
    this.confirmFileList(this.fileList);
    // 全部上传成功后，通知父页面启用提交按钮
    if(fileList.filter(function(index :any,row:any){return index.status=="uploading"}).length<=0){
      this.$emit("setsubdisabled",false);
      this.$emit("refresh",false);
    }else{
      console.log("成功!");
    }
    
  }

  // 上传出错
  handleError(err: any, file: any) {
    this.$message.error(`文件${file.name}上传失败`);
    this.fileList = this.fileList.filter(item => item.uid !== file.uid);
    this.confirmFileList(this.fileList);
    // 如果没有文件，启用提交按钮
    if(this.fileList.length<=0){
      this.$emit("setsubdisabled",false);
      this.$emit("refresh",false);
    }
  }

  // 删除已上传的文件
  handleDelete(index: number, row: any) {
    // 删除之前上传的文件
    if(row.old){
      this.deletefileList.push(row);
      this.deleteFileList(this.deletefileList);
      this.defaultFileList = this.defaultFileList.filter(item => item.uid !== row.uid);      
    }
    
    // 删除本次上传的文件
    this.fileList = this.fileList.filter(item => item.uid !== row.uid);
    this.confirmFileList(this.fileList);
  }

  // 文件类型图标
  getFileIconClass(name: string) {
    if (
      name.endsWith("jpg") ||
      name.endsWith("bmp") ||
      name.endsWith("jpeg") ||
      name.endsWith("png")
    )
      return "iconfont icontupian";
    if (name.endsWith("ppt") || name.endsWith("pptx"))
      return "iconfont iconppt";
    if (name.endsWith("doc") || name.endsWith("docx"))
      return "iconfont iconword";
    if (name.endsWith("xls") || name.endsWith("xlsx"))
      return "iconfont iconExcel";
    if (name.endsWith("txt")) return "iconfont icontxt";
    if (name.endsWith("pdf")) return "iconfont iconpdf";

    return "iconfont iconqitaleixingwenjian";
  }

  getFileAClass(name: string) {
    if (
      name.endsWith("jpg") ||
      name.endsWith("bmp") ||
      name.endsWith("jpeg") ||
      name.endsWith("png")
    ) {
      return "can-preview";
    }

    return "none";
  }
  // 文件大小单位转换
  filterType(val: number) {
    if (!val || val === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(val) / Math.log(k));

    return (val / Math.pow(k, i)).toPrecision(3) + " " + sizes[i];
  }
}
